var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "kr-embedded-method-wrapper",
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      !_vm.isLoaded
        ? _c(
            "div",
            { staticClass: "kr-loading-container" },
            [
              _c("div", { staticClass: "kr-loading-label" }, [
                _vm._v(_vm._s(_vm.translate("loading_payment_method"))),
              ]),
              _c("KryptonLoadingAnimation"),
            ],
            1
          )
        : _vm._e(),
      _vm.loadPaymentMethod
        ? _c(
            _vm.getComponent(),
            _vm._b(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isLoaded,
                    expression: "isLoaded",
                  },
                ],
                tag: "component",
                staticClass: "kr-embedded-method",
                on: { ready: _vm.onReady },
              },
              "component",
              { method: _vm.shortMethodKey },
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }